<template>
    <el-dialog
            title="选择执行人"
            :visible.sync="staffDialogVisible"
            width="720px"
            :before-close="handleClose">
            <div class="staff-box">
                  <div class="search-member">
                      <el-input v-model="loginName" placeholder="请输入员工姓名或部门名称"></el-input>
                      <img src="~@/assets/gbIcon/search_icon.png" @click.stop="searchEmployee">
                  </div>
                  <div class="table-box" v-loading="waiting">
                    <el-table
                    :data="list.subaccountData"
                    style="width: 100%"
                    ref="singleTable"
                    innerpage
                    >
                    <el-table-column
                    width="46">
                    <template slot-scope="scope">
                           <el-radio v-model="radio" :label="scope.$index" @change.native="getCurrentRow(scope.row)"></el-radio> 
                    </template>
                    </el-table-column>
                    <el-table-column
                        prop="employeeName"
                        label="成员信息"
                        >
                        <template slot-scope="scope">
                             <div class="emInfor">
                                 <img :src="scope.row.avatarUrl" alt="" class="imgUrl">
                                <div class="box">
                                    <template v-if="scope.row.employeeName">
                                            <el-tooltip effect="light" :content="scope.row.employeeName" placement="top" v-if="scope.row.employeeName.length>16">
                                                <span :class="['emName','textOverflow',scope.row.leaderInDept == 1?'emLd':'']">{{scope.row.employeeName}}</span>
                                            </el-tooltip>
                                            <span v-else :class="['emName','textOverflow',scope.row.leaderInDept == 1?'emLd':'']">{{scope.row.employeeName}}</span>
                                    </template>
                                    <span v-else>{{'--'}}</span>
                                    
                                    <i v-if="scope.row.leaderInDept == 1">上级</i>
                                    <span class="emPhone" v-if="scope.row.phoneNumber">{{scope.row.phoneNumber}}</span>
                                </div>
                             </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="loginName"
                        label="账号"
                        align="center">
                        <template slot-scope="scope">
                            <template v-if="scope.row.loginName">
                                    <el-tooltip effect="light" :content="scope.row.loginName" placement="top" v-if="scope.row.loginName.length>20">
                                        <span class="textOverflow">{{scope.row.loginName}}</span>
                                    </el-tooltip>
                                    <span v-else class="textOverflow">{{scope.row.loginName}}</span>
                            </template>
                            <span v-else>{{'--'}}</span>
                                
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="departmentNames"
                        label="部门">
                        <template slot-scope="scope">
                            <template v-if="scope.row.departmentNames">
                                    <el-tooltip class="item" effect="light" :content="scope.row.departmentNames" placement="top" v-if="scope.row.departmentNames.length>11">
                                        <span class="textOverflow">{{scope.row.departmentNames}}</span>
                                    </el-tooltip>
                                    <span v-else class="textOverflow">{{scope.row.departmentNames}}</span>
                            </template>
                            <span v-else>{{'--'}}</span>
                               
                        </template>
                    </el-table-column> 
                    <el-table-column
                        prop="position"
                        label="职务"
                        align="center"
                        width="83"
                        >
                        <template slot-scope="scope">
                            <template v-if="scope.row.position">
                                    <el-tooltip effect="light" v-if="scope.row.position.length>4" :content="scope.row.position" placement="center">
                                        <span class="textOverflow">{{scope.row.position}}</span>
                                    </el-tooltip>
                                    <span v-else>{{scope.row.position}}</span>
                            </template>
                            <span v-else>{{'--'}}</span>
                        </template>
                    </el-table-column>
                    </el-table>
                  </div>
                  <pagination v-if="list.subaccountData.length" :pageNum="list.pageNum" :pageSize="list.pageSize" :total="list.total" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange" :key="list.pageNum" />
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="dialog-cancel" size="small" w88 @click="staffDialogVisible = false">取 消</el-button>
                <el-button type="pure" size="small" w88 @click="choiceOperator">确 定</el-button>
            </span>
        </el-dialog>
</template>
<script>
import pagination from '@/components/pagination/'
import { listEmployee} from '@/views/clue/api/cleaningApi'
import {mapState} from 'vuex'
export default {
    components:{
        pagination,
    },
    data(){
        return{
             waiting:false,
             staffDialogVisible:false,
             list:{
                pageNum: 1,
                pageSize: 10,
                total: 0,
                subaccountData: []//子账号
             },
             loginName:'',//登录名
             status:0,//账号状态
             roleId:'',//角色
             radio:'',//单选项
             bindAccountObj:{},//员工账号纤细
             avatarUrl:require('@/assets/zxrdefalutImg.png'),
             superAdminObj:{}//超级管理员数据
        }
    },
    computed:{
        ...mapState({
            staffInfo:state => state.user.staffInfo
        })
    },
    mounted(){
        
    },
    methods:{
        iniFun(){
            this.loginName = ''
            this.radio = ''
            this.staffDialogVisible = true
            this.superAdminDataObj()
        },
        superAdminDataObj(){
            let obj ={
                    bindAccountId:'',
                    avatarUrl:this.avatarUrl,
                    employeeName:'超级管理员',
                    // phoneNumber:this.staffInfo.phoneNumber,
                    loginName:this.staffInfo.loginName,
                    departmentNames:'--',
                    position:'--'
            }
            this.superAdminObj = obj
            this.getlistEmployee(1)
        },
        choiceOperator(){
             this.$emit('getBindAccountObj',this.bindAccountObj)
            this.$parent.getListSortData()
             this.staffDialogVisible = false
        },
       getCurrentRow(row){
           let obj = {
               bindAccountId:row.bindAccountId,
               employeeName:row.employeeName,
               loginName:row.loginName
           }
           this.bindAccountObj = obj
       },
       searchEmployee(){
           this.list.pageNum = 1
           this.loginName = this.loginName == '超级管理员'?this.staffInfo.loginName:this.loginName
           let val = (this.loginName == '' || this.loginName == this.staffInfo.loginName)?1:''
           this.getlistEmployee(val)
       },
       async getlistEmployee(val){
          let params ={
              pageSize:this.list.pageSize,
              pageNum:this.list.pageNum,
              loginName:this.loginName,
              status:this.status,
          }
          this.waiting = true
          const res = await listEmployee(params)
          this.waiting = false
          if(res.code == 200){
              if(res.data){
                    this.list.subaccountData = res.data.list
                    this.list.total = res.data.total
                    if(val == 1){
                        this.list.subaccountData.unshift(this.superAdminObj)
                    }
              }
              
          }
        },
        handleSizeChange(val){
            this.list.pageSize = val
            this.list.pageNum = 1
            this.getlistEmployee()
        },
        handleCurrentChange(val){
            this.list.pageNum = val
            if(val == 1){
                this.getlistEmployee(val)
            }else{
                this.getlistEmployee()
            }
            
        },
        handleClose(){
            this.staffDialogVisible = false
            this.loginName = ''
        }
    }
}
</script>
<style scoped lang='scss'>
::v-deep{
          .el-dialog__body{
              padding-bottom: 0;
          }
          .el-dialog__title{
                  color: #333333;
                  font-weight: bold;
              }
          .staff-box{
                .search-member{
                    position: relative;
                    margin-bottom: 16px;
                    .el-input__inner{
                        line-height: 32px;
                        height: 32px;
                        padding-right: 33px;
                    }
                    img{
                        position: absolute;
                        right: 7px;
                        top: 0;
                        bottom: 0;
                        margin: auto;
                        cursor: pointer;
                    }
                }
                .table-box{
                    height: 415px;
                    overflow: hidden;
                    overflow-y: scroll;
                    .textOverflow{
                        display: block;
                        // width: 100%;
                        color: #333333;
                    }
                }
                .el-table__header thead tr th.el-table__cell{
                        text-align: left;
                }
               .el-table__body td.el-table__cell{
                   text-align: left;
               }
               .el-table td.el-table__cell div{
                   .imgUrl{
                       width: 24px;
                        height: 24px;
                        background: #D8D8D8;
                        border-radius: 50%; 
                        margin-right: 8px;
                   }
               }
               .emInfor{
                   display: flex;
                   align-items: center;
                   .box{
                       width: calc(100% - 32px);
                       span{
                           display: block;
                           &.emLd{
                               max-width: 64%;
                               float: left;
                           }
                           &.emPhone{
                               color: #999999;
                           }
                       }
                        i{
                                border: 1px solid rgba(187, 190, 202, 0.3);
                                background-color: rgba(187, 190, 202, 0.2);
                                font-size: 12px;
                                border-radius: 2px;
                                margin-left: 4px;
                           }
                   }
               }
               .el-pagination__total,.el-pagination__sizes{
                   display: none;
               }
               .el-table__cell:first-child .cell{
                      padding-left: 20px;
               }
               .el-radio__label{
                   display: none;
               }
            }
}
</style>